<template>
  <div class="search-bar" @keyup.13.prevent="filter">
    <search-categories @change="onChange" :ecoSystem="ecoSystem"/>
    <div class="padding-x">
      <div class="columns is-multiline  is-desktop is-mobile">
        <column v-if="getWidth === 'xs'"  size="is-12-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class=" is-grouped">
            <div :class="getEcoClass">
              <div class="width-100 select">
                <select class="width-100" v-model="formEcoSystem" @change.prevent="filter">
                  <option value="all">All Ecosystem</option>
                  <option v-if="category.value && category.value !== 'all'" v-for="category in ecoCategories" :value="category.value" :key="category.value"><div>
                    <img :src="getImgUrl(category.image)" width="30" height="30" alt="">{{category.label}}
                  </div></option>
                </select>
                <span v-if="ecoSystem" class="icon is-left mt-4">
                  <img v-if="ecoSystem !== 'all'" :src="getImgUrl(ecoSystem)" width="20" height="20" alt="">
                </span>
              </div>
            </div>
          </div>
        </column>
        <column size="is-12-mobile is-12-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <p class="control is-expanded has-icons-left">
              <input v-model="formKeyword" class="input" type="search" placeholder="Keyword">
              <span class="icon is-small is-left">
                <i class="fas fa-search"></i>
              </span>
            </p>
          </div>
        </column>
        <column size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <p class="control is-expanded has-icons-left">
              <input v-model="formLocations" class="input" type="search" placeholder="Location">
              <span class="icon is-small is-left">
            <i class="fas fa-map-marker-alt"></i>
          </span>
            </p>
          </div>
        </column>
        <column size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <div class="control is-expanded">
              <div  class="width-100 select">
                <select class="width-100" v-model="formJobCategory" @change.prevent="filter">
                  <option value="--all--">All Jobs</option>
                  <option v-for="type in jobCategories" :value="type.value" :key="type.value">{{type.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </column>
        <column  size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class="is-grouped">
            <div class="control is-expanded">
              <div class="width-100 select">
                <select class="width-100" v-model="formJobType" @change.prevent="filter">
                  <option value="">All Job Types</option>
                  <option v-for="type in jobTypes" :value="type.name" :key="type.id">{{type.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </column>
        <column  size="is-half-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <div class=" is-grouped">
            <div class=" control is-expanded">
              <div class="width-100 select">
                <select class="width-100" v-model="formSalaryRange"  @change.prevent="filter">
                  <option value="">All Salaries</option>
                  <option v-for="sr in salaryRanges" :value="sr.value" :key="sr.value">{{sr.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </column>
        <column v-if="getWidth === 'xs'"  size="is-12-mobile is-12-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd">
          <button class="is-primary button is-fullwidth" @click="filter">Search</button>
        </column>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex'
import SearchCategories from './categories'
import Column from '@/components/general/column'
import {ecoSystemOptions, jobCategoryOptions} from '@/constants/array-constants'

let timeout
export default {
  data () {
    return {
      salaryRanges: [{'label': 'Negotiable', value: 'negotiable'}, {'label': '$50k - $100k', 'value': '50000,100000'}, {'label': '$100k - $200k', 'value': '100000,200000'}],
      jobCategories: jobCategoryOptions,
      ecoCategories: ecoSystemOptions,
      windowWidth: 0
    }
  },
  components: {SearchCategories, Column},
  computed: {
    ...mapState('domain', ['jobTypes']),
    ...mapState('jobs', ['keyword', 'locations', 'jobType', 'salaryRange', 'jobCategory', 'ecoSystem']),
    ...mapGetters('jobs', ['getFilters']),
    formJobCategory: {
      get () { return this.jobCategory },
      set (value) {
        this.setJobCategory(value)
        this.$router.push(`/jobs/${this.ecoSystem}/${this.jobCategory}`)
      }
    },
    formKeyword: {
      get () { return this.keyword },
      set (value) {
        this.setKeyword(value.trim())
        if (value.trim() === '') {
          this.filter()
        }
      }
    },
    formLocations: {
      get () { return this.locations },
      set (value) {
        this.setLocations(value.trim())
        if (value.trim() === '') {
          this.filter()
        }
      }
    },
    formJobType: {
      get () { return this.jobType },
      set (value) { this.setJobType(value) }
    },
    formSalaryRange: {
      get () { return this.salaryRange },
      set (value) { this.setSalaryRange(value) }
    },
    formEcoSystem: {
      get () { return this.ecoSystem },
      set (value) { this.setEcoSystem(value) }
    },
    q () {
      const q = this.$route.meta.stacks ? 'stacks' : null
      return this.$route.query.q || q
    },
    getWidth () {
      if (this.windowWidth <= 760) {
        return 'xs'
      }
      return 'lg'
    },
    getEcoClass () {
      return this.ecoSystem !== 'all' ? 'control is-expanded has-icons-left' : 'control is-expanded'
    }
  },
  methods: {
    ...mapActions('jobs', ['search']),
    ...mapActions('domain', ['fetchJobTypes']),
    ...mapMutations('jobs', ['setFilters', 'setKeyword', 'setLocations', 'setJobType', 'setSalaryRange', 'setJobCategory', 'setEcoSystem']),
    onChange (jobCategory) {
      this.setEcoSystem(jobCategory)
      this.$router.push(`/jobs/${jobCategory}/${this.jobCategory}`)
      this.filter()
      console.log('')
    },
    getImgUrl (imageName) {
      if (imageName === 'all') {
        return ''
      }
      const images = require.context('../../../assets/', false, /\.png$/)
      return images('./' + imageName + '.png')
    },
    async filter () {
      if (timeout) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(async () => {
        await this.search({
          ...this.getFilters
        })
      }, 300)
    }
  },
  mounted () {
    this.keyword = this.q
    this.fetchJobTypes()
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="scss" scoped>
  .search-bar {
    background: #fff;
    width: 101%;
    padding: 14px 0 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: -24px;
    border-bottom: 1px solid #ddd;

    .filter-wpr {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 0 auto;
      width: 80%;
      .field {
        width: 25%;
        .select {
          width: 100%;
          select {
            width: 100%;
          }
        }
      }
      .field:not(:last-child) {
        margin-right: 24px;
        margin-bottom: 0;
      }

      .control.has-icons-left .icon, .control.has-icons-right .icon {
        height: 40px;
        width: 2.75em;
      }

      .control.has-icons-left .input:focus ~ .icon, .control.has-icons-left .select:focus ~ .icon, .control.has-icons-right .input:focus ~ .icon, .control.has-icons-right .select:focus ~ .icon {
        color: #111;
      }
      .control {
        margin-top: 0;
      }
    }
    .width-100{
      width: 100%;
    }
    .padding-x{
      padding-left: 30px;
      padding-right: 36px;
    }
    .mt-4{
      margin-top: 4px
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/search/index.vue